module.exports = __webpack_public_path__ + "img/xiaochengxu.93f236ea.png";